 import moment from "moment-jalaali";
import React, { useEffect, useState } from "react"; 
const LocationListFetch=(props)=>{ 

 
    return(
        <>
        {(props.location!=undefined && props.location!=[] )&& props.location.map((item, index) => {return(
            <div className="row my-2">
<button className="btn btn-danger btn-block" onClick={props.click} value={item.location}>
    <p style={{pointerEvents:"none"}}> لوکیشن :
    {item.location}
    </p>

    <p style={{pointerEvents:"none"}}> 
    {item.operator.name}
    </p>

    <p style={{pointerEvents:"none"}}> 
    { moment(item.time*1000).format('jYYYY/jM/jD H:m:s')}
    </p>

    </button>
</div>
 )  
            })}
        </>
    )
}
export default LocationListFetch;